import { Clock } from "lucide-react";
import { dateShort } from "@/lib/format";
import { describeAppt } from "@/lib/appt";

// "Wed, Oct 15 · Appt 8:00 AM" — date and/or appointment for one stop.
export const apptText = (date, appt) =>
  [date && dateShort(`${date}T12:00:00`), describeAppt(appt)].filter(Boolean).join(" \u00b7 ");

export const ApptLine = ({ date, appt, testId, className = "" }) => {
  const text = apptText(date, appt);
  return (
    <div className={`inline-flex items-center gap-1 text-xs ${text ? "text-slate-700 font-medium" : "text-slate-400"} ${className}`} data-testid={testId}>
      <Clock className="w-3.5 h-3.5 shrink-0" /> {text || "No appointment set"}
    </div>
  );
};
